import { QueryClient } from "@tanstack/react-query";
import { PostHog } from "posthog-js";
import { redirect } from "react-router";
import { UTAH_PROGRAM_ID } from "~/participant/constants/utah.constants";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { notFound } from "~/shared/util/notFound";

export async function utahOnboardingLoader(queryClient: QueryClient, posthogClient?: PostHog) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  /** Redirect to the dashboard if the user has already completed the onboarding */
  if (user.codeOfConduct) {
    return redirect("/");
  }

  /** Show 404 if the user is not part of the Utah program */
  if (!user?.profile?.programs?.some((program) => program.id === UTAH_PROGRAM_ID)) {
    return notFound();
  }

  posthogClient?.startSessionRecording({ sampling: true, linked_flag: true });

  return null;
}
